import pitch from "../images/lineup/pitch.png"
import pitchShirt from "../images/lineup/shirt.png"

export const images = {
    pitch: pitch,
    pitchShirt: pitchShirt
}
